export default "__VITE_ASSET__BLOiUAai__"